<template>
    <header class="sticky-top">
<!--
        <nav class="navbar bg-white border-bottom">
            <div class="container">
&lt;!&ndash;                <a v-if="showmenu == 'hidden' || showmenu == 'newsletter'" class="navbar-brand" style="cursor: pointer"
                   :href="hrefstartpage">
                    <svg id="header-logo" role="img">
                        <title>{{ envCompany }}</title>
                        <use xlink:href="/assets/img/icon-sprite.svg#global.logo"
                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>
                <a v-else class="navbar-brand" @click="gotostartpage" style="cursor: pointer">
                    <svg id="header-logo" role="img">
                        <title>{{ envCompany }}</title>
                        <use xlink:href="/assets/img/icon-sprite.svg#global.logo"
                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>&ndash;&gt;

                &lt;!&ndash; 2022.07.15:&ndash;&gt;
                <nav class="usermenu ml-auto">

&lt;!&ndash;                    <a class="small text-primary hover-primary mr-3" role="button" data-toggle="modal"
                       data-target="#newaccountinfoModal" data-content="newaccountmessage">
                        <svg class="icon icon-xs mr-1">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>{{ __('lang.my_account.info.newaccount.goto_old') }}
                    </a>

                    <a class="myhelios" role="button" data-toggle="dropdown" data-target="#dropdown-login"
                       data-reference="parent" data-display="static" aria-expanded="false">

                        <span class="d-none d-md-inline" v-if="user.auth">{{ user.first_name }}
                            {{ user.last_name }}</span>
                        <span class="d-none d-md-inline" v-else>{{ __('lang.my_account.my_helios') }}</span>
                        &lt;!&ndash; @click="openlogin" &ndash;&gt;

                        <svg class="icon icon-rg ml-2 mr-0">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.nav.account"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                    </a>&ndash;&gt;
&lt;!&ndash;
                    <a v-show="showmenu != 'hidden'" class="search ml-3" role="button" id="Searchdropdown"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg class="icon icon-rg">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.nav.search"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                    </a>


                    <form class="dropdown-menu" aria-labelledby="Searchdropdown">
                        &lt;!&ndash; search: &ndash;&gt;
                        <div class="border-0 rounded-0 w-100 p-2 bg-gradient-gray shadow pb-5" id="dropdown-search">
                            &lt;!&ndash; <div class="d-flex flex-column py-5" id="dropdown-search"> &ndash;&gt;
                            <div class="container">
                                <div class="col-12 text-right">
                                    <button class="close my-2 d-none d-sm-block" id="header-close-btn" type="button"
                                            aria-label="Close">
                                        <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </button>
                                </div>
                                <div class="container flex-grow-1">
                                    <div class="row justify-content-center">
                                        <div class="col-12 col-md-8">
                                            <p>{{ __('lang.nav.productsearch.info.text') }}</p>
                                            <productsearch parentID="main"></productsearch>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
&ndash;&gt;

                    &lt;!&ndash;
                                        <a v-show="showmenu != 'hidden'" class="cart ml-3" role="button"
                                           @click.prevent="$parent.$refs.main.listenerchild({nav: '4', searchflag: search_flag })">
                                            <svg class="icon icon-rg">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.nav.cart"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <div class="badge badge-primary">{{ shoppingcart.filter(row => (row.productmarker != -1 &&
                                                row.productmarker != -2)).length }}</div>

                                        </a>
                                         <a class="language ml-3" role="button">
                                            <svg class="icon icon-rg">
                                                <use :xlink:href="'/assets/img/icon-sprite.svg#'+xlink"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg><span class="badge badge-primary">{{language}}</span>
                                        </a> &ndash;&gt;
&lt;!&ndash;                    <a class="language ml-3" role="button" data-toggle="dropdown" data-target="#dropdown-language"
                       aria-expanded="false" id="languageDropdown">
                        <svg class="icon icon-rg">
                            <use :xlink:href="'/assets/img/icon-sprite.svg#' + xlink"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg><span class="badge badge-primary">{{ language }}</span>
                    </a>&ndash;&gt;




                </nav>

            </div>
        </nav>
-->


        <!-- <div id="dropdown-login" class="dropdown-menu border-0 rounded-0 w-100 p-2 shadow" :class="needLogin ?  'show' : ''" v-if="session == null"> -->
        <div id="dropdown-login" class="dropdown-menu border-0 rounded-0 w-100 p-2  bg-gradient-gray  shadow"
             :class="needLogin ? 'show' : ''" v-if="!user.auth">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-right">
                        <button class="close my-2 d-none d-sm-block" id="header-close-btn" type="button" aria-label="Close"
                                @click="closeLogin">
                            <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="row mt-md-n3 mb-1 align-items-center">
                    <div class="col-12 col-md-4">
                        <p class="h4 font-weight-light">{{ __('lang.my_account.current_state') }}</p>
                        <p class="h6 font-weight-light mb-3">{{ __('lang.my_account.guest') }}</p>
                        <div class="text-primary my-3">
                            <svg class="icon icon-lg">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </div>
                        <p class="small">
                            {{ __('lang.my_account.for_project_save_1') }} <a class="text-primary hover-primary"
                                                                              :href="registration_link">{{ __('lang.my_account.for_project_save_2') }} </a>
                        </p>
                        <hr class="d-block "><!--  d-md-none -->
                        <p class="text-primary font-weight-bold small">{{
                                __('lang.my_account.info.newaccount.required.text') }} <br />

                            <a class="text-primary hover-primary" role="button" data-toggle="modal"
                               data-target="#newaccountinfoModal" data-content="newaccountmessage">
                                <svg class="icon icon-xs mr-1">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>{{ __('lang.my_account.info.newaccount.required.href') }}
                            </a>

                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <div id="login-view">
                            <p class="h4 font-weight-light">{{ __('lang.my_account.login') }}</p>
                            <div class="form-row">
                                <div class="form-group col-12 col-md-9">
                                    <input class="form-control border" type="email" :placeholder="__('lang.my_account.email')" name="reg_name"
                                           v-model="input.email" autocomplete="username">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12 col-md-9">
                                    <input class="form-control border" type="password" :placeholder="__('lang.my_account.password')"
                                           name="reg_passwd" v-model="input.password" autocomplete="current-password">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-6 col-md-3">
                                    <button id="login-form-btn" class="btn btn-primary border-0 text-uppercase"
                                            @click="login()">{{ __('lang.my_account.login') }}</button>
                                </div>
                                <div class="form-group col-6 col-md-6 text-right">
                                    <a role="button" :href="passforgot_link"
                                       class="btn btn-gray-20 btn-sm small pwdreset-btn">{{
                                            __('lang.my_account.forgot_password') }}</a>
                                </div>
                            </div>
                            <hr class="d-block d-md-none">
                        </div>
                        <div id="pwdreset-view" class="d-none">
                            <p class="display-4 font-weight-light">{{ __('lang.my_account.forgot_password') }}</p>
                            <p class="small">{{ __('lang.my_account.forgot_password_mail') }}</p>
                            <form action="/login/" method="post">
                                <div class="form-row">
                                    <div class="form-group col-12 col-md-9">
                                        <input class="form-control border" type="email" placeholder="E-Mail" name="reg_name"
                                               value="" autocomplete="username">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-6 col-md-3">
                                        <button class="btn btn-primary border-0 text-uppercase">{{ __('lang.btn.send')
                                            }}</button>
                                    </div>
                                    <div class="form-group col-6 col-md-6 text-right">
                                        <a role="button" class="btn btn-gray-20 btn-sm small login-btn">{{
                                                __('lang.btn.back') }}</a>
                                    </div>
                                </div>
                            </form>
                            <hr class="d-block d-md-none">
                        </div>
                    </div>
                    <hr class="d-block d-sm-none">
                    <div class="col-12 col-md-4">
                        <p class="h4 font-weight-light">{{ __('lang.my_account.not_registered') }}</p>
                        <p class="display-5 font-weight-light">{{ __('lang.my_account.benefit_advantages') }}</p>
                        <ul class="list-unstyled square">
                            <li>{{ __('lang.my_account.advantage_projectmanagement') }}</li>
                            <li>{{ __('lang.my_account.advantage_projectsave') }}</li>
                            <li>{{ __('lang.my_account.advantage_team') }}</li>
                        </ul>
                        <p class="font-weight-medium text-underlined">
                            {{ __('lang.my_account.register_now') }} <a :href="registration_link"
                                                                        class="font-weight-medium text-primary hover-primary">{{ __('lang.my_account.register_here')
                            }}</a>
                            {{ __('lang.my_account.register') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="dropdown-menu border-0 rounded-0 w-100 p-2 bg-gradient-gray shadow" id="dropdown-login" v-else>
            <div class="container">
                <div class="row">
                    <div class="col-12 text-right">
                        <button class="close my-2 d-none d-sm-block" id="header-close-btn" type="button" aria-label="Close">
                            <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="row mt-md-n3 mb-1 align-items-center">
                    <div class="col-12 col-md-4">
                        <p class="h4 font-weight-light">{{ __('lang.my_account.current_state') }}</p>
                        <p class="small mb-1">{{ __('lang.my_account.loggedin_as') }}</p>
                        <!-- <p class="h4 text-primary font-weight-black mb-0">{{session.first_name}} {{session.last_name}}</p> -->
                        <p class="h4 text-primary font-weight-black mb-0">{{ user.first_name }} {{ user.last_name }}</p>
                        <p class="h6 font-weight-light mb-3" v-if="user.business_customer == 1">
                            {{ __('lang.my_account.business_customer') }}</p>
                        <p class="h6 font-weight-light mb-3" v-else>{{ __('lang.my_account.private_person') }}</p>


                        <p>
                            <a class="btn btn-sm btn-primary border-0" @click="logoutUser">{{ __('lang.my_account.logout')
                                }}</a>
                        </p>
                        <hr class="d-block d-md-none">
                    </div>
                    <div class="col-12 col-md-8">
                        <ul class="nav nav-inline nav-fill">
                            <li class="nav-item col-4" v-show="user.registration_complete">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('projects')" data-content="/projekte/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.projects"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="d-none d-md-inline">{{ __('lang.my_account.my_projects') }}</span>
                                </a>
                            </li>
                            <li class="nav-item col-4" v-show="user.registration_complete">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('configurations')" data-content="/auslegungen/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.specifications"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="d-none d-md-inline">{{ __('lang.my_account.my_configuration') }}</span>
                                </a>
                            </li>
                            <li class="nav-item col-4" v-show="user.registration_complete">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('articles')" data-content="/artikel/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.products"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="d-none d-md-inline">{{ __('lang.my_account.my_article') }}</span>
                                </a>
                            </li>
                            <li class="nav-item col-4" v-show="user.registration_complete">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('contacts')" data-content="/kontakte/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.contacts"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="d-none d-md-inline">{{ __('lang.my_account.my_contacts') }}</span>
                                </a>
                            </li>
                            <li class="nav-item col-4">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('profile')" data-content="/profil/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.profile"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    <span class="d-none d-md-inline">{{ __('lang.my_account.my_profile') }}</span>
                                </a>
                            </li>
                            <li class="nav-item col-4" v-show="user.registration_complete">
                                <a class="nav-link" role="button" data-toggle="modal" data-target="#accountModal"
                                   @click="setIframeUrl('options')" data-content="/einstellungen/">
                                    <svg class="icon icon-xl mx-auto d-block">
                                        <use xlink:href="/assets/img/icon-sprite.svg#account.nav.settings"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>{{ __('lang.my_account.options') }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- search: -->



        <!-- :search -->

        <!-- <div class="alert alert-danger alert-dismissible text-center rounded-0 fade" :class="error ? 'show' : '' " role="alert">
        <p class="mb-0"><strong>{{__('lang.my_account.login_error')}}:</strong> {{__('lang.my_account.login_error_message')}}</p>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">
                <svg class="icon icon-xs">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </span>
        </button>
    </div> -->
        <!--Countries/Languages:  -->
        <!-- <b-form-select class="form-control custom-select" v-model="test" :options="country_options_test" ></b-form-select>
    <b-form-select class="form-control custom-select" v-model="selected.country" :options="country_options"  @change='getCountryLanguages()' id="country" @click.prevent></b-form-select> -->
        <div class="dropdown-menu border-0 rounded-0 w-100 p-2 bg-gradient-gray shadow" id="dropdown-language"
             aria-labelledby="languageDropdown">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-right">
                        <button class="close my-2 d-none d-sm-block" id="header-close-btn" type="button" aria-label="Close">
                            <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                        <!-- for touch devices-->
                        <!-- <form class="nav language d-block d-lg-none"> -->
                        <div class="nav language d-block d-lg-none">
                            <div class="form-row justify-content-center">
                                <div class="form-group col-6 text-center">
                                    <label class="col-form-label col-form-label-sm" for="country">{{
                                            __('lang.localization.country') }}</label>

                                    <b-form-select class="form-control custom-select" v-model="selected.country"
                                                   :options="country_options" @change='getCountryLanguages()' id="country"
                                                   @click.native.stop></b-form-select>

                                </div>
                            </div>



                            <div class="form-row justify-content-center">
                                <div class="form-group col-6 text-center">
                                    <label class="col-form-label col-form-label-sm" for="language">{{
                                            __('lang.localization.language') }}</label>
                                    <!-- <select class="form-control custom-select" name="language" required>
                                    <option value="de" selected>DE</option>
                                    <option value="en">EN</option>
                                    <option value="fr">FR</option>
                                </select> -->
                                    <b-form-select class="form-control custom-select" v-model="selected.language"
                                                   :options="language_options" id="language" @click.native.stop>
                                    </b-form-select>
                                </div>
                            </div>
                            <div class="form-row justify-content-center">
                                <div class="form-group col-6 text-center">
                                    <button class="btn btn-primary btn-block border-0" type="submit"
                                            @click.prevent="setLocale(selected.country, selected.language)">{{
                                            __('lang.btn.save') }}</button>
                                </div>
                            </div>
                            <!-- </form> -->
                        </div>
                        <!-- for desktop-->
                        <ul class="nav language justify-content-center d-none d-lg-flex">
                            <li class="nav-item text-center ml-2 ml-md-5"><span class="nav-link d-flex flex-column" data-country="de">
<!--                                    <ul class="nav sub-nav position-absolute sub-nav-count-2">--><!---->
                                <ul class="nav sub-nav position-absolute sub-nav-count-2  d-flex align-self-center align-items-center">
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="de"
                                                                data-country="de" @click="setLocale('deu', 'de')">
                                                <!-- :href="setlang('de')" -->
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>DE</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.de"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="uk"
                                                                data-country="de" @click="setLocale('deu', 'en')">
                                                <!-- :href="setlang('en')" -->
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>EN</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.uk"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <!--<li class="nav-item"><a class="nav-link" role="button" data-language="fr"
                                                               data-country="de" @click="setLocale('deu', 'fr')">
                                               <div class="flag-item">
                                                   <svg class="icon icon-sm" role="img">
                                                       <title>FR</title>
                                                       <use xlink:href="/assets/img/icon-sprite.svg#country.fr"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                   </svg>
                                               </div>
                                           </a></li>
                                       <li class="nav-item"><a class="nav-link" role="button" data-language="pl"
                                                               data-country="de" @click="setLocale('deu', 'pl')">
                                               <div class="flag-item">
                                                   <svg class="icon icon-sm" role="img">
                                                       <title>PL</title>
                                                       <use xlink:href="/assets/img/icon-sprite.svg#country.pl"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                   </svg>
                                               </div>
                                           </a></li>


                                                                                <li class="nav-item"><a class="nav-link" role="button" data-language="tr"
                                                                                        data-country="de" @click="setLocale('deu','tr')">
                                                                                        <div class="flag-item">
                                                                                            <svg class="icon icon-sm" role="img">
                                                                                                <title>TR</title>
                                                                                                <use xlink:href="/assets/img/icon-sprite.svg#country.tr"
                                                                                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                            </svg>
                                                                                        </div>
                                                                                    </a></li>
                                                                                <li class="nav-item"><a class="nav-link" role="button" data-language="ru"
                                                                                        data-country="de" @click="setLocale('deu','ru')">
                                                                                        <div class="flag-item">
                                                                                            <svg class="icon icon-sm" role="img">
                                                                                                <title>RU</title>
                                                                                                <use xlink:href="/assets/img/icon-sprite.svg#country.ru"
                                                                                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                            </svg>
                                                                                        </div>
                                                                                    </a></li>
                                                                                <li class="nav-item"><a class="nav-link" role="button" data-language="hu"
                                                                                        data-country="de" @click="setLocale('deu','hu')">
                                                                                        <div class="flag-item">
                                                                                            <svg class="icon icon-sm" role="img">
                                                                                                <title>HU</title>
                                                                                                <use xlink:href="/assets/img/icon-sprite.svg#country.hu"
                                                                                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                            </svg>
                                                                                        </div>
                                                                                    </a></li> -->
                                    </ul>
                                    <div class="flag-item">
                                        <svg class="icon icon-lg" role="img">
                                            <title>DE</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#country.de"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </div>
                                    <p class="mt-2 text-uppercase">{{__('lang.country.de') }}</p>
                                </span>
                            </li>
                            <li class="nav-item text-center ml-2 ml-md-5"><span class="nav-link d-flex flex-column" data-country="at">
                                    <ul class="nav sub-nav position-absolute sub-nav-count-2 d-flex align-self-center align-items-center">
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="de"
                                                                data-country="at" @click="setLocale('aut', 'de')">
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>DE</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.de"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="uk"
                                                                data-country="at" @click="setLocale('aut', 'en')">
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>EN</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.uk"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                    </ul>
                                    <div class="flag-item">
                                        <svg class="icon icon-lg" role="img">
                                            <title>AT</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#country.at"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </div>
                                    <p class="mt-2 text-uppercase">{{__('lang.country.at') }}</p>
                                </span>
                            </li>
                            <li class="nav-item text-center ml-2 ml-md-5"><span class="nav-link d-flex flex-column" data-country="fr">
                                    <ul class="nav sub-nav position-absolute sub-nav-count-1 d-flex align-self-center align-items-center">
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="fr"
                                                                data-country="fr" @click="setLocale('fra', 'fr')">
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>FR</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.fr"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                    </ul>
                                    <div class="flag-item">
                                        <svg class="icon icon-lg" role="img">
                                            <title>FR</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#country.fr"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </div>
                                    <p class="mt-2 text-uppercase">{{__('lang.country.fr') }}</p>
                                </span>
                            </li>
                            <li class="nav-item text-center ml-2 ml-md-5"><span class="nav-link d-flex flex-column" data-country="in">
                                    <ul class="nav sub-nav position-absolute sub-nav-count-4 d-flex align-self-center align-items-center">
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="de"
                                                                data-country="de" @click="setLocale('___', 'de')">
                                                <!-- :href="setlang('de')" -->
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>DE</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.de"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="uk"
                                                                data-country="de" @click="setLocale('___', 'en')">
                                                <!-- :href="setlang('en')" -->
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>EN</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.uk"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="fr"
                                                                data-country="de" @click="setLocale('___', 'fr')">
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>FR</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.fr"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>
                                        <li class="nav-item"><a class="nav-link" role="button" data-language="pl"
                                                                data-country="de" @click="setLocale('___', 'pl')">
                                                <div class="flag-item">
                                                    <svg class="icon icon-sm" role="img">
                                                        <title>PL</title>
                                                        <use xlink:href="/assets/img/icon-sprite.svg#country.pl"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                            </a></li>

                                        <!--
                                                                                 <li class="nav-item"><a class="nav-link" role="button" data-language="tr"
                                                                                         data-country="de" @click="setLocale('deu','tr')">
                                                                                         <div class="flag-item">
                                                                                             <svg class="icon icon-sm" role="img">
                                                                                                 <title>TR</title>
                                                                                                 <use xlink:href="/assets/img/icon-sprite.svg#country.tr"
                                                                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                             </svg>
                                                                                         </div>
                                                                                     </a></li>
                                                                                 <li class="nav-item"><a class="nav-link" role="button" data-language="ru"
                                                                                         data-country="de" @click="setLocale('deu','ru')">
                                                                                         <div class="flag-item">
                                                                                             <svg class="icon icon-sm" role="img">
                                                                                                 <title>RU</title>
                                                                                                 <use xlink:href="/assets/img/icon-sprite.svg#country.ru"
                                                                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                             </svg>
                                                                                         </div>
                                                                                     </a></li>
                                                                                 <li class="nav-item"><a class="nav-link" role="button" data-language="hu"
                                                                                         data-country="de" @click="setLocale('deu','hu')">
                                                                                         <div class="flag-item">
                                                                                             <svg class="icon icon-sm" role="img">
                                                                                                 <title>HU</title>
                                                                                                 <use xlink:href="/assets/img/icon-sprite.svg#country.hu"
                                                                                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                                                             </svg>
                                                                                         </div>
                                                                                     </a></li> -->
                                    </ul>
                                    <div class="flag-item" data-flag="in">
                                        <svg class="icon icon-lg" role="img">
                                            <title>INT</title>
                                            <use xlink:href="/assets/img/icon-sprite.svg#country.international"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </div>
                                    <p class="mt-2 text-uppercase">{{__('lang.country.wo') }}</p>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal fade" id="newaccountinfoModal" tabindex="-1" aria-hidden="true" data-backdrop="false">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 800px !important;">
                <div class="modal-content rounded-lg border-0 shadow-lg">
                    <div class="modal-header border-0 pb-0 row">

                        <!-- Modal Header -->
                        <div class="col-12 text-right">
                            <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                                    id="closenewqaccountinfo"><span aria-hidden="true">
                                    <svg class="icon icon-xs">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                             xmlns:xlink="http://www.w3.org/1999/xlink">
                                        </use>
                                    </svg></span>
                            </button>
                        </div>
                        <div class="col-12 p-4">
                            <h2>{{ __('lang.my_account.info.newaccount.modal.title') }} </h2>
                        </div>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="col-12">
                            <p>{{ __('lang.my_account.info.newaccount.modal.message.p1_1') }}
                                <b>{{ __('lang.my_account.info.newaccount.modal.message.p1_2') }}</b>
                                {{ __('lang.my_account.info.newaccount.modal.message.p1_3') }}
                            </p>
                            <p>{{ __('lang.my_account.info.newaccount.modal.message.p2_1') }}
                                <b>{{ __('lang.my_account.info.newaccount.modal.message.p2_2') }}</b>
                                {{ __('lang.my_account.info.newaccount.modal.message.p2_3') }}
                                <b>{{ __('lang.my_account.info.newaccount.modal.message.p2_4') }}</b>
                                {{ __('lang.my_account.info.newaccount.modal.message.p2_5') }}
                                <a class="text-primary hover-primary" :href="infolink" target="_blank">{{
                                        __('lang.my_account.info.newaccount.modal.message.p2_6') }}</a>

                            </p>
                            <p>{{ __('lang.my_account.info.newaccount.modal.message.p3_1') }}
                                <b>{{ __('lang.my_account.info.newaccount.modal.message.p3_2') }}</b>
                                {{ __('lang.my_account.info.newaccount.modal.message.p3_3') }}
                            </p>
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer border-0">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">{{
                                __('lang.actionbutton.title.close') }}</button>
                    </div>
                </div>
                <!-- </div> -->

            </div>
        </div>
        <!--:Countries/Languages-->
        <div class="d-none">{{ needReload }}</div>

    </header>
</template>

<script>
import userApi from './services/api/user'
import projectApi from './services/api/project'
import globalsApi from './services/api/globals'
import productsearch from './ProductSearch'
import operatingpointApi from './services/api/operatingpointAPI'



export default {
    components: {

        productsearch

    },
    props: [
        'status',
        'showmenu'
    ],
    data() {
        return {
            input: {
                email: null,
                password: null,
            },
            needReload: this.status,
            error: false,
            registration_link: '#',
            passforgot_link: '#',
            selected: {
                country: 'deu',
                language: 'de'
            },
            /* available_countries: [ 'deu', 'aut' ], */
            /* test:'',
            country_options_test:[{value:'1',text:'one'},{value:'2',text:'two'}], */

            country_languages: [
                {
                    country: 'deu', languages: [
                        { value: 'de', text: this.__('lang.localization.language_de') },
                        { value: 'en', text: this.__('lang.localization.language_en') },
                    ]
                },
                {
                    country: 'aut', languages: [
                        { value: 'de', text: this.__('lang.localization.language_de') },
                        { value: 'en', text: this.__('lang.localization.language_en') },
                    ]
                },
                {
                    country: 'fra', languages: [
                        { value: 'fr', text: this.__('lang.localization.language_fr') },
                    ]
                },
                {
                    country: '___', languages: [
                        { value: 'de', text: this.__('lang.localization.language_de') },
                        { value: 'en', text: this.__('lang.localization.language_en') },
                         { value: 'fr', text: this.__('lang.localization.language_fr') },
                         { value: 'pl', text: this.__('lang.localization.language_pl') },
                        /* {value:'tr',text: this.__('lang.localization.language_tr')},
                         {value:'hu',text: this.__('lang.localization.language_hu')},
                         {value:'ru',text: this.__('lang.localization.language_ru')} */
                    ]
                },
            ],
            label: {
                country: this.__('lang.localization.country'),
                language: this.__('lang.localization.language'),
            },
            country_options: [
                { value: 'deu', text: this.__('lang.localization.country_deu') },
                { value: 'aut', text: this.__('lang.localization.country_aut') },

                { value: 'fra', text: this.__('lang.localization.country_fra') },
                { value: '___', text: this.__('lang.localization.country_wol') }

            ],
            language_options: [
                { value: 'de', text: this.__('lang.localization.language_de') },
                { value: 'en', text: this.__('lang.localization.language_en') },
                { value: 'fr', text: this.__('lang.localization.language_fr') },
                { value: 'pl', text: this.__('lang.localization.language_pl') },
                /*
                              {value:'tr',text: this.__('lang.localization.language_tr')},
                              {value:'hu',text: this.__('lang.localization.language_hu')},
                              {value:'ru',text: this.__('lang.localization.language_ru')}
                              */
            ],
            fullpath: '',
            countries: '{"DEU": "DE","AUT": "AT","FRA": "FR", "___":"__"}',
        }

    },
    computed: {
        infolink: function () {
            return this.$lang().locale == 'de' ? this.__('lang.my_account.info.newaccount.modal.message.p2_2_href_de') : this.__('lang.my_account.info.newaccount.modal.message.p2_2_href_en')
        },
        contentnav: {
            get() {
                return this.$store.state.globalData.contentnav
            },
            set(value) {
                this.$store.commit('globalData/updateContentnav', value)
            }
        },
        hrefstartpage: function () {
            this.contentnav = 1
            var hrefstart = window.location.origin
            return hrefstart

        },
        xlink: function () {
            var xlink = 'global.nav.language'
            var selcountry = this.$store.state.user.selectedlocale.country
            switch (selcountry) {
                case 'deu':
                    xlink = 'country.de'
                    break;
                case 'aut':
                    xlink = 'country.at'
                    break;
                case 'fra':
                    xlink = 'country.fr'
                    break;
                case '___':
                    xlink = 'country.international'
                    break;
                default:
                    xlink = 'global.nav.language'
                    break;
            }
            return xlink
        },
        selectedlocale: {
            get() {
                return this.$store.state.user.selectedlocale
            },
            set(value) {
                this.$store.commit('user/updateSelectedlocale', value)
            }
        },
        language: function () {
            //return this.$store.state.user.selectedlocale.language.toUpperCase();
            return this.$lang().locale.toUpperCase();
        },
        envCompany: function () {
            return process.env.MIX_APP_COMPANY
        },
        user: {
            get() {
                return this.$store.state.user.user
            },
            set(value) {
                this.$store.commit('user/updateUser', value)
            }
        },
        formData: {
            get() {
                return this.$store.state.user.formData
            },
            set(value) {
                this.$store.commit('user/updateFormData', value)
            }
        },
        acousticdistance: {
            get() {
                return this.$store.state.productdata.AcousticDistanceData
            },
            set(value) {
                this.$store.commit('productdata/updateAcousticDistance', value)
            }
        },
        session: {
            get() {
                return this.$store.state.user.session
            },
            set(value) {
                this.$store.commit('user/updateSession', value)
            }
        },
        projectData: {
            get() {
                return this.$store.state.user.projectData
            },
            set(value) {
                this.$store.commit('user/updateProjectData', value)
            }
        },
        needLogin: {
            get() {
                return this.$store.state.user.needLogin
            },
            set(value) {
                this.$store.commit('user/updateNeedLogin', value)
            }
        },
        update: {
            get() {
                return this.$store.state.globalData.update
            },
            set(value) {
                this.$store.commit('globalData/updateUpdate', value)
            }
        },
        reRender: {
            get() {
                return this.$store.state.globalData.reRender
            },
            set(value) {
                this.$store.commit('globalData/updateReRender', value)
            }
        },
        navigation: {
            get() {
                return this.$store.state.globalData.navigation
            },
            set(value) {
                this.$store.commit('globalData/updateNavigation', value)
            }
        },
        shoppingcart: {
            get() {
                return this.$store.state.shoppingcart.shoppingcartlist
            }
        },
        alertStore: {
            get() {
                return this.$store.state.alert.value
            },
            set(value) {
                this.$store.commit('validation/updateAlert', value)
            }
        },
        search_flag: {
            get() {
                return this.$store.state.shoppingcart.search_flag
            }
        },
        reRenderShoppingcart: {
            get() {
                return this.$store.state.shoppingcart.reRenderShoppingcart
            },
            set(value) {
                this.$store.commit('shoppingcart/updatereRenderShoppingcart', value)
            }
        },
        applocales: {
            get() {
                return this.$store.state.globalData.applocales
            },
            set(value) {
                this.$store.commit('user/updateAppLocales', value)
            }


        }




    },
    watch: {
        needLogin: {
            deep: true,
            handler() {
                if (this.needLogin == true) {


                }
            },
        },
        update: {
            deep: true,
            handler() {
                if (this.update.configuration == 1 && this.session != null) {
                    this.getUserProject()
                    this.update.configuration = 0
                }

            },
        },
        needReload: {
            handler() {

                if (this.needReload == 1) {
                    this.getUserData();
                }
            },
            deep: true
        },
        '$store.state.user.selectedlocale': {
            immediate: true,
            deep: true,
            handler() {
                this.selected.country = this.$store.state.user.selectedlocale.country
                this.selected.language = this.$store.state.user.selectedlocale.language
                //this.selected = this.$store.state.user.selectedlocale
            }
        },
    },
    methods: {
        /* openlogin:function() {
            this.needLogin = true

        }, */
        getCountryLanguages: function () {
            var selectedcountry = this.selected.country
            var countrylanguages = this.country_languages.find(({ country }) => country === selectedcountry)
            this.language_options = countrylanguages.languages
            this.selected.language = countrylanguages.languages[0].value
        },
        setlang: function (lang) {
            return this.$route.path + lang
        },
        setIframeUrl: function (url) {
            /* if(this.session != null && this.session.registration_complete && this.session.auth){
                this.navigation = url
            }
            if(this.session != null && !this.session.registration_complete && this.session.auth){
                this.navigation = url //'registration'
            } */

            if (this.user.auth && this.user.registration_complete) {
                this.navigation = url
            }
            if (this.user.auth && !this.session.registration_complete) {
                this.navigation = url //'registration'
            }

        },
        login() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.loginUser()
        },
        loginUser() {
            axios.post('/login/keycloak', this.input).then(response => {

                //this.session = response.data;
                this.session = true;
                this.user = response.data;

                if (this.user.registration_complete == false) {


                    this.$store.dispatch('alert/setAlert', { type: 'info', message: this.__('lang.kwl.alert.registration_not_complete'), time: 9999999 })

                }
                else {
                    /*own articles if api set articles we don't need this:*/
                    this.getUserArticles()
                    this.getUserProject()
                    /*set locale to userdata:*/


                    /* check user country_reg in available_countries then check */
                    if (this.country_languages.find(({ country }) => country === response.data.countries_iso) && this.selectedlocale.country != response.data.countries_iso) {
                        this.setLocale(response.data.countries_iso, this.$lang().locale) //// ToDo here must ISO country!!!! countries_id
                    }
                    /*this.selectedlocale.country=response.data.countries_price // // ToDo here must ISO country!!!! countries_id
                    this.selectedlocale.language=this.$lang().locale.toUpperCase();
                    */

                    this.reRenderShoppingcart = 1
                    this.$store.dispatch('alert/resetState')


                    this.$store.dispatch('operatingpoint/InitLoad', this.user);
                    this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.message.login_success') })


                }

                document.getElementsByTagName("body")[0].classList.remove("is-loading");
            }).catch((error) => {

                console.log(error)
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.kwl.alert.login_faild') })
                document.getElementsByTagName("body")[0].classList.remove("is-loading");
            });
        },
        logoutUser() {
            var session = this.session

            this.$store.dispatch('shoppingcart/resetState')
            this.$store.dispatch('globalData/resetState')
            this.$store.dispatch('user/resetState')
            this.$store.dispatch('validation/resetState')
            this.$store.dispatch('projectData/resetState')
            this.$store.dispatch('operatingpoint/resetState')
            this.$store.dispatch('alert/resetState')
            this.$store.commit('globalData/updateContentnav', 1)
            //window.sessionStorage.removeItem('vuex');
            //window.sessionStorage.clear();
            //window.sessionStorage.setItem('vuex', {});
            //location.reload();
            //storage.clear();
            //this.session = null
            //this.reRender = 1
            //this.nav_position = 1
            var response = userApi.logout(session);
            /* cadenas Forced logout:
            https://portalname.partcommunity.com/3d-cad-models/logout
            */
            this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.message.logout_success') })

        },
        async getUserProject() {


            var response = await projectApi.returnFullProjectData(this.session); //this.user

            if (response == 404 || !Array.isArray(response)) {
                this.projectData = []
            } else if (response >= 400) {
                //this.error = response;
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.kwl.alert.load_project_data_faild') })
            } else {
                this.projectData = response
            }
        },
        async getUserArticles() {
            var response = await globalsApi.returnUserArticles(this.session); //this.user

            this.user.articles = response.data
        },

        closeLogin() {
            this.needLogin = false
        },
        setRegistrationLink() {
            axios.post('/user/registration').then(response => {

                this.registration_link = response.data
            }).catch((error) => {
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.kwl.alert.load_registration_link_faild') })
            });
        },
        setPassforgotLink() {
            axios.post('/user/passforgot').then(response => {
                this.passforgot_link = response.data
            }).catch((error) => {
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.kwl.alert.load_passforgot_link_faild') })
            });
        },
        getUserData() {

            axios.post('/user/basic/data').then(response => {
                this.session = true //response.data;
                this.user = response.data
                this.getUserSettings()
                /*own articles if api set articles we don't need this:*/
                this.getUserArticles()

                this.getUserProject()

            }).catch((error) => {

                console.log(error)
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.kwl.alert.load_user_data_faild') })
                this.error = true;
            });
        },

        async getUserSettings() {
            var response = await operatingpointApi.getUserSettings(this.session); //this.user

            this.$store.commit('operatingpoint/setSettings', response.data)
        },

        async initialiseData(language_id) {
            globalsApi.returnFormData({ language_id: language_id })
                .then(response => {
                    this.formData = response.data
                }).catch(error => {
                console.log(error);
            });
            globalsApi.getAcousticDistanceData()
                .then(response => {

                    this.acousticdistance = response.data.distancedata
                }).catch(error => {
                console.log(error);
            });

            /* !!! evnt. remove:
        operatingpointApi.getUnits()
            .then(response => {
                console.log('initialiseData getUnits')
                console.log(response.data)
                this.$store.commit('operatingpoint/setDefaults', response.data)
            }).catch(error => {
                console.log('Fehler operatingpointAPI.getUnits()');
                console.log(error);
            });
        */


        },
        setLocale(country, language) {
            var params = { country: country, language: language }  //navigator.language,
            var path


            //--if(this.selectedlocale.country!=country){
            axios.post('/switchLanguageCountry', params).then(response => {
                path = response.data.href

                if (this.showmenu == 'hidden') {
                    //replace  lang bevor /get


                    if (!this.applocales.available.languages.includes(language)) language = this.applocales.fallback.language
                    if (!this.applocales.available.countries.includes(country)) country = this.applocales.fallback.country


                    this.fullpath = this.fullpath.replace(/language_id=[^&]*/, "language_id=" + language)
                    this.fullpath = this.fullpath.replace(/country_id=[^&]*/, "country_id=" + country)


                    let idx_get = this.fullpath.indexOf("get/");
                    let fullpath_tmp = this.fullpath.substring(idx_get);

                    let idx = fullpath_tmp.indexOf("language_id");
                    let replacement = 'language_id=' + language;
                    path = path + '/' + fullpath_tmp.substring(0, idx) + replacement + fullpath_tmp.substring(idx + replacement.length);
                }

                window.location.replace(path);


                this.$lang().setLocale(language)  //das funktioniert!  kann man for lang switcher nutzen


                window._locale = this.$lang().locale
                window._country = this.convertCountryIsoAlphas(country, 2);

                //this.selectedLocale=this.$lang().locale
                //--this.language=this.$lang().locale.toUpperCase();
                this.reRenderShoppingcart = 1

                this.$store.commit('user/updateSelectedlocale', params)



            }).catch((error) => {

                console.log(error)

            });
            //--}



        },
        gotostartpage() {
            this.contentnav = 1
        },
        convertCountryIsoAlphas(code, alpha) {

            const allcountries = JSON.parse(this.countries);

            for (const [code3, code2] of Object.entries(allcountries)) {
                if (code2.toUpperCase() === code.toUpperCase()) {
                    return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                } else if (code3.toUpperCase() === code.toUpperCase()) {
                    return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                }
            }

            return code.toLowerCase();
        },
        updateCountryLanguage(arg_country,arg_language) {


            /*20240523: new url structure de-de:*/
            var country
            var urlcountry
            var language
            var urllanguage

            const url = new URL(window.location);
            const pathname = url.pathname;
            //console.log('pathname', pathname);
            // Create a URLSearchParams object from the URL's search parameters
            const urlparams = new URLSearchParams(url.search);
            const regex_countrylang = /^\/([a-z_]{2,3}|__)-([a-z]{2})(?:\/|$)/;
            const match_countrylang = pathname.match(regex_countrylang);

            if (match_countrylang) {
                urlcountry = match_countrylang[1];
                urllanguage = match_countrylang[2];
                country = this.convertCountryIsoAlphas(urlcountry, 3);
                language = urllanguage;

               // console.log('match_countrylang', country+':'+language);

            } else {
                console.log('No match_countrylang found');
                const regex_lang = /^\/([a-z]{2})(?:\/|$)/;
                const match_lang = pathname.match(regex_lang);
                if (match_lang) {
                    const urllanguage = match_lang[1];
                    country = null
                    language = urllanguage;

                } else {
                 //   console.log('No match_lang found');
                    country = null
                    language = null;
                }
            }
            if (language == null || !this.applocales.available.languages.includes(language)) {
                if (this.selectedlocale.language && this.applocales.available.languages.includes(this.selectedlocale.language)) language = this.selectedlocale.language
                else language = this.applocales.fallback.language
            }
            if (country == null || !this.applocales.available.countries.includes(country)) {
                if (this.selectedlocale.country && this.applocales.available.countries.includes(this.selectedlocale.country)) country = this.selectedlocale.country
                else country = this.applocales.fallback.country
            }


           /*:new url structure de-de*/

          if( language !== arg_language || country !== arg_country ){
                // Store a flag in sessionStorage to indicate that the URL has been updated
                sessionStorage.setItem('urlUpdated', 'true');
                // Update the URL with the new search parameters
                url.search = urlparams.toString();
                var params = { country: country, language:language }  //navigator.language,
                this.selected.country = country
                this.selected.language = language
                this.$store.commit('user/updateSelectedlocale', params)
                this.$lang().setLocale(language)
                window._locale = language
                window._country = country
                //now rewrite all to new url: domain/country-language/.....
                window.location.href = url.toString();

            }

            if( language !== urllanguage || country !== this.convertCountryIsoAlphas(urlcountry, 3)) {
                var tmp_lang=language
                var tmp_country=country
                if (urllanguage==null || !this.applocales.available.languages.includes(urllanguage)) {
                    if (this.selected.language && this.applocales.available.languages.includes(this.selected.language)) tmp_lang = this.selected.language
                    else tmp_lang = this.applocales.fallback.language

                }
                var country_alpha3= urlcountry?this.convertCountryIsoAlphas(urlcountry, 3):null
                if (urlcountry==null || !this.applocales.available.countries.includes(country_alpha3)) {
                    if (this.selected.country && this.applocales.available.countries.includes(this.selected.country)) tmp_country = this.selected.country
                    else tmp_country = this.applocales.fallback.country

                }
                //this.$router.replace('/'+ tmp_country+'-'+tmp_lang);
                // Find the index of '/get'
                const getIndex = pathname.indexOf('/get');

                var params = { country: tmp_country, language:tmp_lang }  //navigator.language,
                this.selected.country = tmp_country
                this.selected.language = tmp_lang
                this.$store.commit('user/updateSelectedlocale', params)
                this.$lang().setLocale(tmp_lang)

                tmp_country=this.convertCountryIsoAlphas(tmp_country, 2)
                window._locale = tmp_lang //tmp_lang
                window._country = tmp_country //


                // If '/get' is found in the pathname
                if (getIndex !== -1) {
                    // Create the new path by replacing everything before '/get' with '/de-de'
                    const newPath = '/'+ tmp_country+'-'+tmp_lang + pathname.substring(getIndex);

                    // Construct the new URL
                    const newUrl = `${url.origin}${newPath}${url.search}`;

                    // Use history.replaceState to change the URL without reloading the page
                    window.history.replaceState(null, '', newUrl);
                }
                else {
                    //this.$router.replace('/'+ tmp_country+'-'+tmp_lang);
                    const newPath = '/'+ tmp_country+'-'+tmp_lang;
                    const newUrl = `${url.origin}${newPath}`;
                    window.history.replaceState(null, '', newUrl);
                }


            }




        }

    },
    created() {

        if (window.session_has_user == true) {
            // console.log('session_has_user getuserdata sticky header')
            axios.post('/user/basic/data').then(response => {
                this.session = true;

                this.user = response.data;
                this.getUserSettings()
                /*own articles if api set articles we don't need this:*/
                this.getUserArticles()
                this.getUserProject()
            }).catch((error) => {
                /*  console.log('error')
                    console.log(error)
                    this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.load_user_data_faild')}) */
            });
        }


        //console.log('Stickyheader created' );

        var language = this.selectedlocale.language ?? this.applocales.fallback.language; //!window._locale ? navigator.language : window._locale;
        var country = this.selectedlocale.country ?? this.applocales.fallback.country;


        // Check if the page has already been reloaded and the URL updated
        if (!sessionStorage.getItem('urlUpdated')) {
            // If not, update the URL and reload the page
            this.updateCountryLanguage(country,language);
            console.log('updateCountryLanguage: getItem')

        } else {
            // If yes, remove the flag to reset for future use
            sessionStorage.removeItem('urlUpdated');
            console.log('updateCountryLanguage: removeItem')
        }

        this.initialiseData(language)
        this.setRegistrationLink()
        this.setPassforgotLink()

        if (this.user.auth && !window.session_has_user) {
            this.logoutUser()
        }


        //--if (this.user.auth) {
        if (this.status == 1 || (this.user.auth && window.session_has_user)) {
            this.getUserData();
            //window.history.replaceState(null, null, window.location.pathname);
        }
        /*console.log('this.$route created:');
        console.log(this.$route);*/

        this.fullpath = this.$route.fullPath;

    },
    destroyed() {
    },
    mounted: function () {
        if (this.status == 'registration') {
            this.needLogin = true
        }
        if (this.user.auth && this.user.registration_complete == false) {
            this.$store.dispatch('alert/setAlert', { type: 'info', message: this.__('lang.kwl.alert.registration_not_complete'), time: 9999999 })
        }


        var headerElements = document.getElementsByTagName('header');

        // Add a click event listener to each header element
        for (var i = 0; i < headerElements.length; i++) {
            headerElements[i].addEventListener('click', function(event) {
                // Access the element that was clicked
                var clickedElement = event.target;

                // Log the clicked element's id or tag name
                // console.log('Clicked Element:', clickedElement.id || clickedElement.tagName);
                // console.log('Clicked Element:', clickedElement);

                var clickedElementIsBtn = clickedElement.closest('[role="button"]')

                if (clickedElement.id === 'closeAccountModal' || clickedElement.tagName === 'A' || clickedElement.tagName === 'SPAN' || clickedElement.tagName === 'LI' || clickedElement.tagName === 'svg' || clickedElement.tagName === 'use' || clickedElement.tagName === 'BUTTON') {
                    // console.log('Some other element clickedd');
                    // event.stopPropagation();
                } else if (clickedElement.id === 'login-form-btn') {
                    // event.stopPropagation();
                    document.getElementById('dropdown-login').classList.remove('show')
                } else {
                    event.stopPropagation();
                }

            });
        }



    },
}
</script>

<style>
.nav.language .sub-nav-count-2 > * {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -2.5rem 0 0 -1.7rem;
    width: 3rem;
    height: 3rem;
}
.nav.language .sub-nav-count-1 > * {
    margin: 1.02rem 0 0 3.2rem;
}

.nav.language .sub-nav-count-4 > *{
    margin: -2.5rem 0 0 -1.3rem;
}

.nav.language .sub-nav-count-3 > * {
    margin: -3rem 0 0 -1.3rem;
}

.nav.language ul.sub-nav{
    transform: none !important;
}
.nav.language .sub-nav-count-1 > :nth-of-type(1){
transform: rotate(120deg) translate(3.5rem) rotate(-120deg);
}

.flag-item[data-flag="in"], .flag-item[data-flag="in"]:hover {
    border: none !important;
}

</style>
